import script from "./NewWorks.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewWorks.vue?vue&type=script&lang=ts&setup=true"

import "./NewWorks.vue?vue&type=style&index=0&id=3379be6d&lang=less&scoped=true"

import exportComponent from "/Users/ivan/Codes/ripple/wfj-vto-hub/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3379be6d"]])

export default __exports__